import React, {Fragment, PureComponent} from 'react'
import PropTypes from 'prop-types'
import RatesIcon from '@material-ui/icons/MonetizationOn'
import { FlexDataItem } from 'components/FlexDataView'
import Typography from '@material-ui/core/Typography'

export class Rates extends PureComponent {
  static propTypes = {
    dealSheet: PropTypes.object,
    currencyPrice: PropTypes.any
  }

  render = () => {
    const {dealSheet} = this.props
    const currencyPrice = Math.round(Number(this.props.currencyPrice) * 100) / 100
    return (
      <FlexDataItem>
        <Typography variant='subtitle1'><RatesIcon />Rate</Typography>
        <dl>
          <dt>Public Price</dt>
          <dd>{dealSheet.publicSaleRate} {dealSheet.ticker}/{dealSheet.currency.code}</dd>
          <dt>Presale Price</dt>
          <dd>{dealSheet.preSaleRate} {dealSheet.ticker}/{dealSheet.currency.code}</dd>
          {Number(this.props.currencyPrice) !== 1 &&
            <Fragment>
              <dt>{dealSheet.currency.code} price</dt>
              <dd>${currencyPrice}</dd>
            </Fragment>
          }
        </dl>
      </FlexDataItem>
    )
  }
}